import TranslateIcon from '@mui/icons-material/Translate';
import {
  Button,
  Container, Paper,
  Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import React, {
  useCallback, useEffect, useState,
} from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import getEnglishSwatchColour from '../../../api/oc_product/productDataManagement/colourMatching/get/getEnglishSwatchColour';
import getNonEnglishSwatchColour from '../../../api/oc_product/productDataManagement/colourMatching/get/getNonEnglishSwatchColour';
import postColorSwatchingLogs from '../../../api/oc_product/productDataManagement/colourMatching/post/postColorSwatchingLogs';
import addSwatchcolour from '../../../api/oc_product/productDataManagement/colourMatching/post/postSwatchColour';
import { ColorSwatchingContext } from './ColorSwatchingContext';
import ColorSwatchingLogs from './ColorSwatchingLogs';
import ColourDataTable from './components/ColourTable';
import NewMappingPopover from './components/NewMapping';
import SearchColour from './components/SearchColour';

function TabPanel({
  children,
  value,
  index,
  ...other
}) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.defaultProps = {
  children: {},
  index: 0,
  value: 0,
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number,
  value: PropTypes.number,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

function ColourMatching() {
  const [rowsData, setRows] = useState([]);
  const [searchValue, setSearchValue] = React.useState('');
  const [colourType, setcolourType] = React.useState(1);
  const language = useSelector((state) => state.language.language);
  const langName = language?.LanguageName;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openAddModal, setOpenAddModal] = React.useState(false);
  const [colourNameForNewMapping, setColourNameForNewMapping] = React.useState('');
  const [enabledMapingButton, setEnabledMapingButton] = React.useState(true);
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [tabValue, setTabValue] = React.useState(0);
  const [tabIndex, setTabIndex] = React.useState(0);
  const [searchLabel, setSearchLabel] = React.useState('Primary Colour');
  const [total, setTotal] = React.useState(0);
  const [mainEnglishColoursName, setMainEnglishColoursName] = React.useState([]);

  const [englishSwatchColoursName, setEnglishSwatchColoursName] = React.useState([]);
  const [translatedSwatchColoursName, setTranslatedSwatchColoursName] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedColourNameForNewMapping, setSelectedColourNameForNewMapping] = React.useState('');
  // logs
  const [fromDate, setFromDate] = React.useState(null);
  const [toDate, setToDate] = React.useState(null);
  const [resetData, setResetData] = React.useState(false);
  const [logs, setLogs] = React.useState([]);
  const [logsTotalPages, setLogsTotalPages] = React.useState();
  const [logsPerPage, setLogsPerPage] = React.useState(10);
  const [logsTotalRows, setLogsTotalRows] = React.useState(0);
  const [logcurrentPage, setLogCurrentPage] = React.useState(1);
  const tabs = ['Colours', 'Logs'];
  const useStyles = makeStyles({
    indicator: {
      backgroundColor: '#199fb1 !important', // secondary color
      height: '4px !important',
    },
    selected: {
      color: '#fff !important',
      opacity: '1 !important',
    },
    tabRoot: {
      color: '#fff !important',
      width: '33%',
    },
    table: {
      '& .MuiTableCell-root': {
        paddingTop: '6px',
        paddingBottom: '6px',
      },
    },
    cell: {
      borderRight: '1px solid rgba(224, 224, 224, 1)',
      '&:last-child': {
        borderRight: 'none',
      },
      '&.MuiTableCell-head': {
        backgroundColor: '#fafafa', // grey[100]
      },
      width: '70%',
      '&:first-child': {
        width: '30%',
      },
    },
  });
  const styles = useStyles();

  const getSwatchColourDetails = async (languageId, colourName, SelectedcolourType) => {
    try {
      setLoading(true);
      const response = (languageId === 1) ? await getEnglishSwatchColour(languageId, colourName, SelectedcolourType)
        : await getNonEnglishSwatchColour(languageId, colourName, SelectedcolourType);
      if (response) {
        const data = response?.data;
        if (colourName === '') {
          if (languageId === 1) {
            setMainEnglishColoursName(response?.data);
            setEnglishSwatchColoursName(response?.data.flatMap((d) => d.Colours).flatMap((s) => s.Colour).filter((x, i, a) => a.indexOf(x) === i));
          } else {
            setTranslatedSwatchColoursName(response?.data.map((t) => t.TranslatedColour).filter((x, i, a) => a.indexOf(x) === i));
          }
        }
        setRows(data);
        setPage(0);
        if (searchValue === '') {
          setTotal(data.length);
          if (languageId !== 1) {
            const totalGrouped = (Object.groupBy(data, (e) => e.TranslatedColour));
            setTotal(Object.getOwnPropertyNames(totalGrouped).length);
          }
        }
        setLoading(false);
      }
    } catch (error) {
      console.error('Error fetching Swatch Colour Details:', error);
      setRows([]);
      setLoading(false);
    }
  };

  const fetchLogs = async () => {
    const logsData = await postColorSwatchingLogs(
      logcurrentPage,
      logsPerPage,
      searchValue,
      fromDate,
      toDate,
    );
    setLogs(logsData.data.Data);
    setLogsTotalPages(logsData.data.Pagination.PageCount);
    setLogsTotalRows(logsData.data.Summary.TotalRowCount);
  };
  const contextValue = React.useMemo(() => (
    {
      fromDate,
      setFromDate,
      toDate,
      setToDate,
      fetchLogs,
      setAnchorEl,
      anchorEl,
      searchValue,
      setSearchValue,
      setRows,
      tabIndex,
      setTabIndex,
      logsTotalPages,
      setLogsTotalPages,
      logsTotalRows,
      setLogsTotalRows,
    }
  ), [
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    fetchLogs,
    setAnchorEl,
    anchorEl,
    searchValue,
    setSearchValue,
    setRows,
    tabIndex,
    setTabIndex,
    logsTotalPages,
    setLogsTotalPages,
    logsTotalRows,
    setLogsTotalRows,
    logcurrentPage,
    setLogCurrentPage,
    getSwatchColourDetails,
  ]);

  const addColourDetails = useCallback(async () => {
    try {
      if (language.LanguageId === 1) {
        await addSwatchcolour(language.LanguageId, colourNameForNewMapping, selectedColourNameForNewMapping);
      } else {
        await addSwatchcolour(language.LanguageId, selectedColourNameForNewMapping, colourNameForNewMapping);
      }
      toast.success('Colour successfully added');
    } catch (error) {
      console.error('Error while adding the colour:', error);
    } finally {
      setColourNameForNewMapping('');
      setSelectedColourNameForNewMapping('');
      getSwatchColourDetails(language.LanguageId, searchValue, colourType);
      setOpenAddModal(false);
    }
  }, [colourNameForNewMapping, selectedColourNameForNewMapping, searchValue, colourType]);

  const handleOnTabChange = (event, newValue) => {
    setTabIndex(newValue);
    setTabValue(newValue);
    setRows([]);
    setLogsTotalPages(0);
    setLogsTotalRows(0);
    setLogCurrentPage(1);
    setTabValue(newValue);
    setSearchValue('');
    if (newValue === 1) {
      setcolourType(3);
      setResetData(true);
    } else {
      setcolourType(1);
      getSwatchColourDetails(language.LanguageId, searchValue, 1);
      setResetData(true);
    }
  };

  const handleChangePageForLogs = (event, newPage) => {
    setLogCurrentPage(newPage);
  };

  const handleChangeItemsPerPageForLogs = (event) => {
    const newItemsPerPage = event.target.value;
    const newPageCount = Math.ceil(logsTotalRows / newItemsPerPage);
    const newPage = Math.min(logcurrentPage, newPageCount);
    setLogsPerPage(newItemsPerPage);
    setLogCurrentPage(newPage);
  };

  const handleFilterReset = () => {
    setSearchValue('');
    setFromDate(null);
    setToDate(null);
    setResetData(true);
  };

  const handleModalOpen = () => {
    setOpenAddModal(true);
  };

  const handleModalClose = () => {
    setOpenAddModal(false);
  };
  const handleSearch = () => {
    if (language.LanguageId && searchValue && (colourType === 1 || colourType === 2)) {
      getSwatchColourDetails(language.LanguageId, searchValue, colourType);
    }
    if (colourType === 3) {
      fetchLogs();
    }
  };
  const handleReset = () => {
    setSearchValue('');
    setcolourType(1);
    getSwatchColourDetails(language.LanguageId, '', colourType);
  };
  const colorHexCodes = {
    purple: '#800080',
    cream: '#FFFDD0',
    silver: '#C0C0C0',
    green: '#008000',
    pink: '#FFC0CB',
    pin: '#FF7373',
    offWhite: '#FAF9F6',
    darkBlue: '#00008B',
    grey: '#808080',
    red: '#FF0000',
    brown: '#A52A2A',
    multi: '#FF00FF',
    gold: '#FFD700',
    beige: '#F5F5DC',
    black: '#000000',
    blue: '#0000FF',
    yellow: '#FFFF00',
    white: '#FFFFFF',
    'Dark Brown': '#654321',
    orange: '#FFA500',
    'Dark Grey': '#A9A9A9',
    Navy: '#000080',
  };

  React.useEffect(() => {
    if (resetData) {
      fetchLogs();
      setResetData(false);
    }
  }, [resetData, searchValue]);

  React.useEffect(() => {
    fetchLogs();
  }, [logcurrentPage, logsPerPage]);

  useEffect(() => {
    setSearchValue('');
    setcolourType(1);
    if (language.LanguageId) {
      setEnabledMapingButton(false);
      getSwatchColourDetails(language.LanguageId, searchValue, colourType);
    } else {
      setEnabledMapingButton(true);
    }
  }, [language]);
  return (
    <ColorSwatchingContext.Provider value={contextValue}>
      <Container maxWidth="xl">

        <style>
          {`
          .custom-scrollbar {
            scrollbar-width: thin;
            scrollbar-color: #888 #f1f1f1;
          }

          .custom-scrollbar::-webkit-scrollbar {
            width: 10px;
          }

          .custom-scrollbar::-webkit-scrollbar-track {
            background: #f1f1f1;
          }

          .custom-scrollbar::-webkit-scrollbar-thumb {
            background-color: #888;
            border-radius: 10px;
            border: 2px solid #f1f1f1;
          }

          .custom-scrollbar::-webkit-scrollbar-thumb:hover {
            background-color: #555;
          }
        `}
        </style>
        <div className="flex w-[100%] h-full gap-2 pt-2 m-8 mt-1">
          <div className="flex flex-col w-full">
            <div className="flex flex-col justify-between mt-4">
              <Typography variant="h3" className="pl-8" sx={{ width: 800 }}>
                Colour Matching
                <Chip
                  label={langName}
                  color="secondary"
                  icon={<TranslateIcon />}
                  variant="outlined"
                  sx={{
                    ml: 1, fontWeight: 'bold',
                  }}
                />
              </Typography>
              <Typography variant="h7" className="pl-9" sx={{ width: 400 }}> Map and Merge Swatch colours to Primay colours</Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 2,
                  justifyContent: 'flex-end',
                  ml: 50,
                }}
              >
                <Paper
                  elevation={1}
                  sx={{
                    borderRadius: '20px',
                    padding: 1,
                    textAlign: 'left',
                    width: 150,
                    border: '2px solid #5A9EA8',
                    marginBottom: '15px',
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{
                      color: '#5A9EA8',
                      fontWeight: 'bold',
                    }}
                  >
                    Total:
                    {' '}
                    [
                    {langName}
                    ]
                  </Typography>
                  <Typography variant="h4">
                    <center>
                      {total}
                    </center>
                  </Typography>
                </Paper>
              </Box>
              <div className="flex pl-1">
                <div className="-mt-5" style={{ minWidth: '250px', height: '100px' }}>
                  <SearchColour
                    language={language.LanguageId}
                    searchValue={searchValue}
                    setSearchValue={setSearchValue}
                    searchLabel={searchLabel}
                    setSearchLabel={setSearchLabel}
                    onSearch={handleSearch}
                    onReset={handleReset}
                    colourType={colourType}
                    setcolourType={setcolourType}
                    setTabValue={setTabValue}
                    tabValue={tabValue}
                  />
                </div>
                <div className="flex justify-end w-full mt-2">
                  <Button
                    sx={{
                      width: '180px',
                      borderRadius: 30,
                      height: '43px',
                      backgroundColor: '#384451',
                      color: 'white',
                      fontWeight: 'bold',
                      paddingX: 2,
                      // mt: 7,
                      '& .MuiSelect-icon': { color: 'white' },
                    }}
                    onClick={(event) => handleModalOpen(event)}
                    variant="contained"
                    disabled={enabledMapingButton}
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{
                        color: '#fff',
                        fontWeight: 'bold',
                      }}
                    >
                      {' '}
                      +
                      {' '}
                      New Mapping
                    </Typography>
                  </Button>

                  <NewMappingPopover
                    language={language.LanguageId}
                    colourNameForNewMapping={colourNameForNewMapping}
                    selectedColourNameForNewMapping={selectedColourNameForNewMapping}
                    setColourNameForNewMapping={setColourNameForNewMapping}
                    setSelectedColourNameForNewMapping={setSelectedColourNameForNewMapping}
                    addColourDetails={addColourDetails}
                    mainEnglishColoursName={mainEnglishColoursName}
                    translatedSwatchColoursName={translatedSwatchColoursName}
                    englishSwatchColoursName={englishSwatchColoursName}
                    openAddModal={openAddModal}
                    handleModalClose={handleModalClose}
                    langName={langName}
                  />

                </div>
              </div>
              <Tabs
                value={tabValue}
                onChange={handleOnTabChange}
                classes={{
                  indicator: styles.indicator,
                  root: styles.selected,
                }}
                variant="fullWidth"
                scrollButtons="auto"
                allowScrollButtonsMobile
                className="flex flex-row"
                sx={{
                  borderTopLeftRadius: '16px',
                  borderTopRightRadius: '16px',
                  overflow: 'hidden',
                  position: 'sticky',
                  top: 0,
                  zIndex: 1000,
                  backgroundColor: '#384451',
                }}
              >
                {tabs.map((tab) => (
                  <Tab
                    {...a11yProps(tabValue)}
                    key={tab}
                    label={tab}
                    classes={{
                      root: styles.tabRoot,
                      selected: styles.selected,
                    }}
                    sx={{ maxWidth: 'none', ml: 'auto', mr: 'auto' }}
                  />
                ))}
              </Tabs>
              <TabPanel value={tabValue} index={0}>
                <ColourDataTable
                  loading={loading}
                  language={language.LanguageId}
                  rowsData={rowsData}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  handleChangePage={(event, newPage) => setPage(newPage)}
                  handleChangeRowsPerPage={
                    (event) => {
                      setRowsPerPage(parseInt(event.target.value, 10));
                      setPage(0);
                    }
                  }
                  colorHexCodes={colorHexCodes}
                  searchValue={searchValue}
                  colourType={colourType}
                  getSwatchColourDetails={getSwatchColourDetails}
                  swatchColoursName={mainEnglishColoursName}
                  translatedSwatchColoursName={translatedSwatchColoursName}
                  langName={langName}
                />
              </TabPanel>
              <TabPanel value={tabValue} index={1}>
                <ColorSwatchingLogs
                  handleChangePage={handleChangePageForLogs}
                  handleChangeItemsPerPage={handleChangeItemsPerPageForLogs}
                  handleFilterReset={handleFilterReset}
                  logs={logs}
                  count={logsTotalPages}
                  page={logcurrentPage}
                  logsPerPage={logsPerPage}
                  searchValue={searchValue}
                  fetchLogs={fetchLogs}
                />
              </TabPanel>

            </div>
          </div>
        </div>
      </Container>
    </ColorSwatchingContext.Provider>
  );
}

export default ColourMatching;
